import script from "./LivingPeopleEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./LivingPeopleEditor.vue?vue&type=script&lang=ts&setup=true"

import "./LivingPeopleEditor.vue?vue&type=style&index=0&id=327f52f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-327f52f2"]])

export default __exports__